import { Check } from '@components/icons'
import cn from 'clsx'
import { FC, useEffect, useState } from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'

interface refinementListProps {
  items: any[]
  currentRefinement: string[]
  refine: any
  createURL: any
  title?: string
  className?: string
  attribute: string
  hasOptions: (a: string, b: boolean) => void
}

const COLLAPSED_COUNT = 5

const RefinementList: FC<refinementListProps> = ({
  items,
  refine,
  attribute,
  hasOptions,
}) => {
  const [showAll, setShowAll] = useState(false)
  const hasEnoughOptions = items.length > 1

  useEffect(() => {
    hasOptions && hasOptions(attribute, hasEnoughOptions)
  }, [attribute, hasEnoughOptions, hasOptions])

  if (!hasEnoughOptions) {
    return <></>
  }

  const sortedItems = [...items].sort(
    (a: any, b: any) => (b.count ?? 0) - (a.count ?? 0)
  )
  const visibleItems = showAll
    ? sortedItems
    : sortedItems.slice(0, COLLAPSED_COUNT)
  const remaining = sortedItems.length - COLLAPSED_COUNT

  return (
    <div className="flex flex-col">
      <ul className="flex flex-col">
        {visibleItems.map((item: any) => {
          const itemName = item?.label?.replace(/_/g, ' ')
          return (
            <li key={item.value}>
              <button
                type="button"
                className="flex items-center gap-3 py-2.5 w-full text-left cursor-pointer"
                onClick={(event) => {
                  event.preventDefault()
                  refine(item.value)
                }}
              >
                <span
                  className={cn(
                    'flex items-center justify-center h-5 w-5 rounded shrink-0',
                    {
                      'bg-brand-chrome': item.isRefined,
                      'border border-ui-grey-25 bg-white': !item.isRefined,
                    }
                  )}
                >
                  {item.isRefined && (
                    <Check fill="white" width={13} height={11} />
                  )}
                </span>
                <span className="body-1 text-text-base capitalize">
                  {itemName}
                </span>
                <span className="ml-auto body-1 text-text-disabled">
                  {item.count?.toLocaleString()}
                </span>
              </button>
            </li>
          )
        })}
      </ul>
      {remaining > 0 && (
        <button
          type="button"
          className="mt-3 self-start body-2 underline text-text-base cursor-pointer"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? 'Show less' : `+ ${remaining} more`}
        </button>
      )}
    </div>
  )
}

const CustomRefinementList = connectRefinementList(RefinementList)

export default CustomRefinementList
